import React from 'react';
import { Button, Modal } from 'flowbite-react';
import { useTranslation } from 'react-i18next';

interface DeleteConfirmDialogProps {
  isOpen: boolean;
  linkDescription: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting: boolean;
}

export const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  isOpen,
  linkDescription,
  onConfirm,
  onCancel,
  isDeleting,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={isOpen} onClose={onCancel} size="md">
      <Modal.Header>{linkDescription}</Modal.Header>
      <Modal.Body>
        <p className="text-gray-700 dark:text-gray-300">
          {t('istiftaLinks.delete.confirmMessage')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          color="failure"
          onClick={onConfirm}
          disabled={isDeleting}
          isProcessing={isDeleting}
        >
          {t('istiftaLinks.delete.confirm')}
        </Button>
        <Button color="gray" onClick={onCancel} disabled={isDeleting}>
          {t('istiftaLinks.delete.cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
